import { APP_BASE_HREF, PathLocationStrategy, PlatformLocation } from "@angular/common";
import { Inject, Injectable, Optional } from "@angular/core";
import { UrlSerializer } from "@angular/router";

@Injectable()
export class PathPreserveQueryLocationStrategy extends PathLocationStrategy {
    constructor(
        private platformLocation: PlatformLocation,
        private urlSerializer: UrlSerializer,
        @Optional() @Inject(APP_BASE_HREF) _baseHref?: string,
    ) {
        super(platformLocation, _baseHref);
    }

    private get search(): string {
        return this.platformLocation?.search ?? "";
    }

    override prepareExternalUrl(internal: string): string {
        const path = super.prepareExternalUrl(internal);
        const existingURLSearchParams = new URLSearchParams(this.search);
        const encValue = existingURLSearchParams.get("enc");

        const urlTree = this.urlSerializer.parse(path);
        if (encValue !== null) {
            urlTree.queryParams = {
                ...urlTree.queryParams,
                enc: encValue,
            };
        }
        return urlTree.toString();
    }
}
